import { AuthenticationMethod } from '@/react/portainer/settings/types';

import { FormError } from '@@/form-components/FormError';

import { LoginForm } from './LoginForm';
import { OAuthLoginButton } from './OAuthLoginButton';
import { AuthCard } from './AuthCard';

export function LoginPanel({
  customBanner,
  onSubmit,
  initialValues,
  oauthLoginUri,
  oauthProvider,
  method,
  authError,
  isStandardLoginVisible,
  onToggleStandardLogin,
}: {
  customBanner?: string;
  method: AuthenticationMethod;
  oauthProvider?: 'Github' | 'Microsoft' | 'Google' | 'OAuth';
  oauthLoginUri?: string;
  authError?: string;
  initialValues?: { username: string; password: string };
  isStandardLoginVisible: boolean;
  onToggleStandardLogin(): void;
  onSubmit(credentials: { username: string; password: string }): void;
}) {
  return (
    <AuthCard>
      <CustomLoginBanner banner={customBanner} />

      {method === AuthenticationMethod.OAuth && !!oauthProvider && (
        <OAuthLoginButton
          provider={oauthProvider}
          onClickShowInternalAuth={onToggleStandardLogin}
          isInternalAuthVisible={isStandardLoginVisible}
          loginUrl={oauthLoginUri || ''}
        />
      )}

      {isStandardLoginVisible && (
        <LoginForm onSubmit={onSubmit} initialValues={initialValues} />
      )}

      {!!authError && (
        <FormError className="m-0 mt-3 w-full justify-end text-right">
          {authError}
        </FormError>
      )}
    </AuthCard>
  );
}

function CustomLoginBanner({ banner }: { banner?: string }) {
  if (!banner) {
    return null;
  }

  return (
    <div>
      <div
        className="login-banner overflow-y-auto whitespace-pre-line"
        data-cy="auth-custom-login-banner-input"
      >
        {banner}
      </div>
    </div>
  );
}
